import React, { useEffect, useState } from "react";
import { useLang } from "../i18n";
import { GALLERY } from "../data";
import { api } from "../lib/api";
import Reveal from "./Reveal";

const STAGGER = ["lg:mt-0", "lg:mt-12", "lg:mt-0", "lg:mt-12"];
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const fullUrl = (u) => (u && u.startsWith("http") ? u : `${BACKEND}${u}`);

export const Gallery = () => {
  const { t, lang } = useLang();
  const [items, setItems] = useState(GALLERY.map((g) => ({ url: g.src, alt: g.alt })));

  useEffect(() => {
    api.get("/gallery").then(({ data }) => {
      if (Array.isArray(data) && data.length) {
        setItems(data.map((d) => ({ url: fullUrl(d.url), alt: d.alt })));
      }
    }).catch(() => {});
  }, []);
  return (
    <section id="gallery" className="py-24 md:py-32 px-5 md:px-10 bg-qs-bg overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {/* Prominent logo showcase */}
        <Reveal className="flex flex-col items-center text-center mb-16 md:mb-20">
          <div className="py-10 md:py-12 px-8 w-full flex justify-center border-y border-qs-border/70 mb-10">
            <img
              src="/logo-mark-white.png"
              alt="Pizzeria Quattro Stelle Logo"
              data-testid="gallery-logo"
              className="h-40 md:h-56 w-auto object-contain"
            />
          </div>
          <p className="font-outfit text-qs-red tracking-[0.3em] uppercase text-xs mb-4">
            {t.gallery.eyebrow}
          </p>
          <h2 className="font-cormorant text-3xl sm:text-4xl lg:text-5xl text-qs-text">
            {t.gallery.title}
          </h2>
          <p className="font-outfit text-qs-text2 max-w-xl mt-4">{t.gallery.subtitle}</p>
        </Reveal>

        {/* Editorial photo grid - 4 real photos */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {items.map((img, i) => (
            <Reveal key={i} delay={(i % 4) * 120} className={STAGGER[i % 4]}>
              <figure
                data-testid={`gallery-img-${i}`}
                className="group relative overflow-hidden aspect-[3/4] shadow-sm hover:shadow-2xl transition-shadow duration-500"
              >
                <img
                  src={img.url}
                  alt={img.alt[lang]}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-[1100ms] ease-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent opacity-80 group-hover:opacity-95 transition-opacity duration-500" />
                <figcaption className="absolute inset-x-0 bottom-0 p-5 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                  <span className="font-cormorant text-white text-lg md:text-xl leading-tight">
                    {img.alt[lang]}
                  </span>
                </figcaption>
                <span className="absolute top-3 left-3 font-script text-qs-gold text-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
